module.exports = __webpack_public_path__ + "static/media/ENVIRONMENT - 644 C.5dd11490.jpg";